
export enum MoveModeCd {
	EXCLUSIVE = 'Exclusive',
	LINEHAUL = 'Linehaul',
	SUPPLEMENTAL = 'Supplemental'}

